import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import { getFingerprintData, getH5DeviceData, getEnumerateDevices, getWebglAttribute, getFontsDisplay, getRTCConnect, getBattery, getPrivate, getLocalCache, fetchSmDeviceId // getNetworkIP,
// getLocation,
// getIpLocation,
} from '../module';
/**
 * 获取所有设备信息方法
 * @param {object} config 用户配置
 */

export var getAllData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _ref$config, config;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$config = _ref.config, config = _ref$config === void 0 ? {} : _ref$config;
            return _context.abrupt("return", new _Promise(function (resolve, reject) {
              var allData = {
                positionResponse: {},
                //地理位置
                fingerprintResponse: {},
                //获取fingerprint2字段
                enumerateDevicesResponse: '',
                //设备枚举
                nativeFingerprintResponse: {},
                //手机设备信息
                webglAttributeResponse: {},
                //webgl属性信息
                fontsDisplayResponse: {},
                //字体显示信息
                rtcConnectResponse: {},
                //rtc返回值,ipv4 ipv6
                epthIpResponse: '',
                //ipv4
                batteryResponse: {},
                //电量信息
                privateResponse: false,
                //是否隐私模式
                localCacheResponse: '',
                networkIPResponse: '',
                smDeviceIdResponse: ''
              };

              try {
                _Promise.all([getFingerprintData(), getEnumerateDevices(), getH5DeviceData(config), getWebglAttribute(), getFontsDisplay(), getRTCConnect(), getBattery(), getPrivate(), getLocalCache(), fetchSmDeviceId(config)]).then(function (res) {
                  allData = {
                    fingerprintResponse: res[0],
                    enumerateDevicesResponse: res[1],
                    nativeFingerprintResponse: res[2],
                    webglAttributeResponse: res[3],
                    fontsDisplayResponse: res[4],
                    rtcConnectResponse: res[5],
                    batteryResponse: res[6],
                    privateResponse: res[7],
                    localCacheResponse: res[8],
                    smDeviceIdResponse: res[9]
                  };
                  resolve(allData);
                }).catch(function (error) {
                  reject(allData);
                });
              } catch (e) {
                reject(allData);
              }
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getAllData(_x) {
    return _ref2.apply(this, arguments);
  };
}();